<template>
  <div class="redBox">
    <!-- 占位 -->
    <div class="red-top-box"></div>
    <!-- <div class="red-top" :class="{'isTop': isTop}"> -->
    <div class="red-top">
      <div v-if="isList" class="canReceive col-yellow">
        <div class="one-row">
          <div class="icon-gou"></div>购物补贴金
        </div>
        <div class="two-row">恭喜发财，大吉大利</div>
      </div>
      <div v-else class="col-yellow f-40 noReceive">你有一个红包待领取</div>
    </div>
    <div class="red-bottom">
      <img src="../assets/icon_open.png" class="openImg" :class="{'isRotate': isRotate && isList}" @click="rotateAction">
      <div v-if="!isList" class="col-yellow f-32 f-bold">{{numDef}}人已领取</div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'redBox',
  props: {
    isList: {
      type: Boolean,
      default: false   // 默认是列表页红包弹窗样式，false时为补贴金红包样式
    }
  },
  data() {
    return {
      isRotate: false,
      isTop: false,
      numDef: window.localStorage.getItem('numDef')? window.localStorage.getItem('numDef'): 700000, // 默认70w人，每次点击加121,
      openid: ''
    }
  },
  methods: {
    rotateAction () {
      let that = this
      that.isRotate = true
      that.getCardInfo()
      // that.isTop = true
      setTimeout(function () {
        that.isRotate = false
        // that.isTop = false
        that.$emit('openRedbox')
        that.numDef = Number(that.numDef)
        that.numDef += 121
      }, 1000)
    },
    getCardInfo (is_count) {
      let that = this
      if (that.openid) {
        let data = {
          openid: that.openid
        }
        if (is_count) data.is_count = 1
        that.$request({
          url: 'cardInfo',
          data: data
        }).then(result => {
          console.log('res', result.data.send_num)
          that.numDef = result.data.send_num
          window.localStorage.setItem('numDef', result.data.send_num)
        })  
      }
    }
  },
  beforeCreate () {
    console.log("----------进入了redBox的beforeCrreate----------------");
  },
  created() {
    console.log("----------进入了redBox的created----------------");
  },
  beforeMount() {
    console.log("----------进入了redBox的beforeMount----------------");
    let that = this
    let openid = window.localStorage.getItem('openid')
    that.openid = openid
    that.getCardInfo()
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less">
.f-bold{font-weight: bold;}
.col-green{color: #55B374;}
.col-yellow{color: #FFE3B6;}
.f-32{font-size: .32rem;line-height: 45rpx;}
.f-40{font-size: .40rem;line-height: 56rpx;}
.icon-gou{
  display: inline-block;
  vertical-align: middle;
  margin-right: .16rem;
  height: 0.38rem;
  width: 0.38rem;
  transform: translateY(-0.04rem);
  background-repeat: no-repeat;
  background-size: cover;
  background-image: url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACYAAAAmCAYAAACoPemuAAAAAXNSR0IArs4c6QAAAERlWElmTU0AKgAAAAgAAYdpAAQAAAABAAAAGgAAAAAAA6ABAAMAAAABAAEAAKACAAQAAAABAAAAJqADAAQAAAABAAAAJgAAAACE8iBbAAAFJ0lEQVRYCc1YPWwcRRR+b893uQOHv6AoPg7ooIACCZBSgIRxnFyMFDshHQKaUIGgokhBAFNQUPGTyjQBISQUrCSF7URAKCiM4vCPBHQk50sUCL9CF19yN3xvZmd2bm/3vI4v0j1pd968mXnv2/l5894yrYOUUkznPt9ErUtlynFZq2qpOuWKdRp55CIzq6tVz2sdqM4f30xttQvPFCn1KMaXUnQ0iPkzCvgInmO8ZceFlH6J4szAVO2Tu4guv04kgChI1JYmZGoTASDl93Nl2y9p3Xz5qsBU/eSt1F6ZBqBnMEND/uA188xXAHCGgg0HuDz6e6/xPYGp2on7iK4cxQzd0aHEzMAiMR0hxUvE2FeFjXXdp/lvGbIyZA9g3BQ+aGvXDDOdIRqa5Mr2bzr0epVUYOrs/B4Yfg+zdH3Un1cgO0iF4hu8efR8JE/n1IWTW6h56UWAexYgN7iezP9B9hTfvnPWyTwmEVgI6jBAee18lHKFF7g89qs3PjOr6p/eSe3mW9C5yw2SU6tobxI4z7Dpbpav9YWbKTN4mirVV9dz/EW7di+1hZcx6wfcR8vMUe6h+LJ2ADMbvXEaX2H2lPZD/DRXqu+7r+wDo2oLTwLmoQgc9lxQut8/EJ3Hvt14zYHSn0jT/QYlarVORTjpIclEiG2P3IyFfupHfEXoErCnKtXd610+z1YHq5d1eQGnOtxz2pXk77F+zpsxOM8I1Ire6Ou4UjpQJFT0BweF5zF/K7pZ2xYHbkgD09eMeHRLcAlXe/qsinipLs7dII8v1zbE/ThSUwYLhVeL3H32mhHnCT/l+vaB0YAafJzwxMFpW9phw5BgECwgs5RyITvixazO0w3pwThQSm4APDFwxhYvOhUhlkBvQhMlmDa5ZvpEHaB66fRtAotgCnQ85YcubTrVSwf2wL292m1bIiimL6mkdvCmiX9sP13KfRtRSTAFOsiLhLK45/yqz+Oqeocut5fgIB/z5XE+ERTxKbou3w1KBksQ4BMCz8BFnrYhX1y2rF+qs3NvY3eai1i1Z9XyfHTneR2TQdESDRe38y3jf3tdI9ZGJlaCaNjzY6GU887p2n66DIKfvHoBZ/ewqs/v9mSUCIr5NA2Xxvnm0b/8vqvxWMrYNEo8lUB8W/UgBcFzUZPKA9xHqja3V2QpoL6i4eHVQcVtAhOWEomDT20a8as+3wVOe2v+UNUX9okb0O7ADmD+mjbyON/08J9WlFpKYOkTMAWSzUDWcPKAHnR8ApMIrtWeiYH6FqC28Y3VPxJUdIsk2o2oIZgCfWdJNmNJh8O2klx2gfO7MX+HpGMsMygZ69sEFsFkNr+kWI7UVh0Ou3oykwLuewqKY4gQZBUykbGFG8FSiMUCO4aoEikWSO4ridEzUAzcDzREY36wl0EFhfmAwSEYkIPKOOcaVG3+Y+yTPUYZQpFc4e6sEYaqzz0BTSd4ZOK3TGDCTjoPaDV/xmyYJIV5lis7H5dmz4/l9yNzRt4nhI6t5pv6HjWCnm8uT3ywZlCS6EhyEoGCbWAIyQEzkaN61zZgwCRJ4nCtSHTb6FXb4BkbvUrVAdNtQeklLMkZzcsL2YxJHJykL4zWKZmSJbGJ7NxWpewAZjbu0CSWFCkVSOeV6hAu71eyLqsel/ISHaILir0MSWwhK4/9MnCb39c1kAmvBRiCG6xfBA7cIP5UceD0byhJRnkf9lwffkPh5OOQxfeUtWfLxD1mG/1y4H7c+eCEH7hfnXGAGqS4k2v0c/h/8fGFLL0nNgwAAAAASUVORK5CYII=');
}
.redBox{
  position: relative;
  margin: 0 auto;
  height: 7.5rem;
  width: 5.9rem;
  background-color: #F15843;
  border-radius: .24rem;
  font-family: PingFang-SC-Bold;
  overflow: hidden;
  .red-top{
    position: absolute;
    top: 0;
    box-sizing: border-box;
    height: 5.44rem;
    width: 200%;
    margin-left: -50%;
    background-image: linear-gradient(180deg, #EE6356 0%, #FF6455 31%, #FF6257 100%);
    border-radius: 0 0 50% 50%;
    box-shadow: 0 3px 14px 0 rgba(223,43,24,0.80);
    // transition: 1s;
    // 补贴金
    .noReceive{
      padding-top: 1.87rem;
    }
    .canReceive{
      font-weight: bold;
      .one-row{
        padding: 1.47rem 0 .2rem;
        font-size: .42rem;
        line-height: .59rem;
        height: 0.59rem;
      }
      .two-row{
        font-size: .48rem;
        line-height: .67rem;
      }
    }
  }
  .red-top-box{
    position: relative;
    top: 0;
    height: 5.44rem;
    width: 200%;
  }
  .isTop{
    top: -100%;
  }
  .isRotate{
    transition: 1s ease-in-out;
    transform: rotateY(360deg);
  }
  .red-bottom{
    position: relative;
    padding-top: 1.12rem;
    .openImg{
      position: absolute;
      top: -0.93rem;
      left: 0;
      right: 0;
      margin: 0 auto;
      height: 1.86rem;
      width: 1.86rem;
      margin: 0 auto;
      border-radius: 50%;
    }
  }
}
</style>
